stateProviders.push({
    name: 'schoolside.settings.parentApp.applicationDeadline',
    url: '/applicationDeadline',
    templateUrl: 'fast/submodules/schoolside/settings/parentApp/applicationDeadline/partials/applicationDeadline.html?v=' + versionNo,
    controller: "ApplicationDeadlineController",
    resolve: {
        help: function(ModelService)
        {
            return ModelService.helpSystem.resolveData('?script=scForDl');
        },
        school: function(SchoolModelService)
        {
            return SchoolModelService.get();
        }
    }
});